(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alarmtotal-leadpage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-at-track]').forEach(function(field) {
    var value = new URLSearchParams(window.location.search).get(field.dataset.atTrack);
    if (value) field.value = value;
  });
  var success = document.querySelector('.at-lead__success');
  if (success) {
    success.focus();
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
